import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

function Recon() {

  const location = useLocation();

  const reconTabs = [
    {
      name: "Settlement",
      path: "/admin/recon",
      match: [
        "/admin/recon",
        "/admin/recon/settlement-report",
        "/admin/recon/restaurant-wise"
      ]
    },
    {
      name: "Transactions",
      path: "/admin/recon/transactions",
      match: ["/admin/recon/transactions"]
    },
    {
      name: "Order Controller",
      path: "/admin/recon/order-controller",
      match: ["/admin/recon/order-controller"]
    },
    {
      name: "All Orders",
      path: "/admin/recon/all-orders-list",
      match: ["/admin/recon/all-orders-list"]
    },
     {
      name: "Global Inventory",
      path: "/admin/recon/global-inventory",
      match: ["/admin/recon/global-inventory"]
    }
  ];

  return (
    <div className="flex h-[89vh] bg-white overflow-hidden ">

      <div className=" shrink-0 w-[200px] bg-white border-r p-3 flex flex-col gap-2 ">

        {reconTabs.map((tab, index) => {

          const isActive = tab.match.some(route => {

            if (route === "/admin/recon") {
              return location.pathname === route; // exact match only
            }

            return location.pathname.startsWith(route);

          });
          return (
            <NavLink
              key={index}
              to={tab.path}
              end={tab.path === "/admin/recon"}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200
              ${isActive
                  ? "bg-[#01C37D] text-white border-l-4 border-[#01C37D]"
                  : "text-gray-600 hover:bg-[#01c37c0e]"
                }`}
            >
              {tab.name}
            </NavLink>
          )
        }
        )}

      </div>

      <div className="p-0 flex-1 overflow-auto hide-scrollbar ">
        <Outlet />
      </div>

    </div>
  );
}

export default Recon;